const homequiz = [
  {
    question: "Who composed the music for the film 'Inception'?",
    options: [
      "Hans Zimmer",
      "John Williams",
      "Ennio Morricone",
      "Alan Silvestri",
    ],
    answer: "Hans Zimmer",
  },
  {
    question: "Who directed the movie 'Parasite'?",
    options: [
      "Guillermo del Toro",
      "Alejandro González",
      "Bong Joon-ho",
      "Pedro Almodóvar",
    ],
    answer: "Bong Joon-ho",
  },
];


const quizData = {

     homequiz: [
    {
      question: "Who composed the music for the film 'Inception'?",
      options: [
        "Hans Zimmer",
        "John Williams",
        "Ennio Morricone",
        "Alan Silvestri",
      ],
      correctAnswer: "Hans Zimmer",
    },
    {
      question: "Who directed the movie 'Parasite'?",
      options: [
        "Guillermo del Toro",
        "Alejandro González",
        "Bong Joon-ho",
        "Pedro Almodóvar",
      ],
      correctAnswer: "Bong Joon-ho",
    },
  ],
     apps: [
    {
      id: 1,
      question:"Which app is primarily used for instant messaging?",
     options:[
         "Instagram",
        "WhatsApp",
        "YouTube",
        "Spotify",
     ],
     correctAnswer:"WhatsApp",
      
    },
     {
      id: 2,
      question:"Which app is owned by Google and is used for watching videos?",
     options:[
         "Instagram",
        "WhatsApp",
        "YouTube",
        "Spotify",
     ],
     correctAnswer:"YouTube",
      
    },
     {
      id: 3,
      question:"Which app is mainly used for professional networking?",
     options:[
         "Instagram",
        "WhatsApp",
        "YouTube",
        "LinkedIn",
     ],
     correctAnswer:"LinkedIn",
      
    },
     {
      id: 4,
      question:"Which app is popular for short-form video content?",
     options:[
         "Zoom",
        "TikTok",
        "Gmail",
        "YouTube",
     ],
     correctAnswer:"TikTok",
      
    },
     {
      id: 5,
      question:"Which app is commonly used for online meetings and video conferencing?",
     options:[
         "Zoom",
        "TikTok",
        "Gmail",
        "YouTube",
     ],
     correctAnswer:"Zoom",
      
    },
     {
      id: 6,
      question:"Which app helps users navigate and find locations?",
     options:[
         "Uber",
        "Google Maps",
        "Telegram",
        "Discord",
     ],
     correctAnswer:"Google Maps",
      
    },
     {
      id: 7,
      question:"Which app is mainly used for music streaming?",
     options:[
         "Spotify",
        "Apple Music",
        "YouTube Music",
        "Amazon Music",
     ],
     correctAnswer:"Spotify",
      
    },
     {
      id: 8,
      question:"Which app is widely used for sharing files between devices?",
     options:[
         "SHAREit",
        "Instagram",
        "Netflix",
        "Reddit",
     ],
     correctAnswer:"SHAREit",
      
    },
     {
      id: 9,
      question:"Which app is owned by Meta and focuses on photo and video sharing?",
     options:[
         "Snapchat",
        "Instagram",
        "Pinterest",
        "X (Twitter)",
     ],
     correctAnswer:"Instagram",
      
    },
     {
      id: 10,
      question:"Which app is used to send and receive emails?",
     options:[
         "Gmail",
        "YouTube",
        "Spotify",
        "TikTok",
     ],
     correctAnswer:"Gmail",
      
    },
   ],
   games: [
    {
      id: 1,
      question:"Which game features the character Mario?",
     options:[
         "Super Mario Bros",
        "The Legend of Zelda",
        "Pokémon",
        "Call of Duty",
     ],
     correctAnswer:"Super Mario Bros",
      
    },
     {
      id: 2,
      question:"In which game do players build structures using blocks?",
     options:[
         "PUBG",
        "Minecraft",
        "Free Fire",
        "Subway Surfers",
     ],
     correctAnswer:"Minecraft",
      
    },
     {
      id: 3,
      question:"Which battle royale game was developed by Krafton?",
     options:[
         "BGMI",
        "Clash of Clans",
        "Candy Crush Saga",
        "Temple Run",
     ],
     correctAnswer:"BGMI",
      
    },
     {
      id: 4,
      question:"Which game is known for its endless running gameplay?",
     options:[
         "Fortnite",
        "Among Us",
        "Roblox",
        "Subway Surfers",
     ],
     correctAnswer:"Subway Surfers",
      
    },
     {
      id: 5,
      question:"In Clash of Clans, what is the main objective?",
     options:[
         "Race cars",
        "Build and defend a village",
        "Solve puzzles",
        "Play football",
     ],
     correctAnswer:"Build and defend a village",
      
    },
     {
      id: 6,
      question:"Which game became famous for identifying impostors among players?",
     options:[
         "Candy Crush Saga",
        "Among Us",
        "Temple Run",
        "Angry Birds",
     ],
     correctAnswer:"Among Us",
      
    },
     {
      id: 7,
      question:"Which game is developed by Epic Games?",
     options:[
         "Free Fire",
        "Fortnite",
        "BGMI",
        "Roblox",
     ],
     correctAnswer:"Fortnite",
      
    },
     {
      id: 8,
      question:"Which game is primarily a puzzle-matching game?",
     options:[
         "Candy Crush Saga",
        "Among Us",
        "Temple Run",
        "Angry Birds",
     ],
     correctAnswer:"Candy Crush Saga",
      
    },
     {
      id: 9,
      question:"In Roblox, players can:",
     options:[
         "Only play racing games",
        "Create and play user-generated games",
        "Only play battle royale games",
        "Only chat with friends",
     ],
     correctAnswer:"Create and play user-generated games",
      
    },
     {
      id: 10,
      question:"Which mobile game features birds being launched from a slingshot?",
     options:[
         "Temple Run",
        "Angry Birds",
        "Clash Royale",
        "Free Fire",
     ],
     correctAnswer:"Angry Birds",
      
    },
   ],
   "android-apps": [
    {
      id: 1,
      question:"Which programming language is mainly used to build Android apps?",
     options:[
         "Swift",
        "Kotlin",
        "Ruby",
        "PHP",
     ],
     correctAnswer:"Kotlin",
      
    },
     {
      id: 2,
      question:" What is the official IDE for Android app development?",
     options:[
         "Android Studio",
        "Visual Studio",
        "IntelliJ IDEA",
        "Eclipse",
     ],
     correctAnswer:"Android Studio",
      
    },
     {
      id: 3,
      question:"In which language are Android app layouts designed?",
     options:[
         "XML",
        "JSON",
        "HTML",
        "CSS",
     ],
     correctAnswer:"XML",
      
    },
     {
      id: 4,
      question:"What is the one-time registration fee for a Google Play Store developer account?",
     options:[
         "$25",
        "Free",
        "$100",
        "$10",
     ],
     correctAnswer:"$25",
      
    },
     {
      id: 5,
      question:"In which file are an Android app's permissions and configuration defined?",
     options:[
         "build.gradle",
        "MainActivity.java",
        "AndroidManifest.xml",
        "styles.xml",
     ],
     correctAnswer:"AndroidManifest.xml",
      
    },
     {
      id: 6,
      question:"Which kernel is the Android operating system based on?",
     options:[
         "Windows",
        "Linux",
        "Unix",
        " macOS",
     ],
     correctAnswer:"Linux",
      
    },
     {
      id: 7,
      question:"What is the file extension of an Android app?",
     options:[
         " .exe",
        " .apk",
        " .app",
        ".zip",
     ],
     correctAnswer:" .apk",
      
    },
     {
      id: 8,
      question:"Which company develops the Android operating system?",
     options:[
         "Apple",
        "Microsoft",
        "Google",
        "Amazon",
     ],
     correctAnswer:"Google",
      
    },
     {
      id: 9,
      question:" Which Google platform is used to show ads inside Android apps?",
     options:[
         " AdSense",
        "AdMob",
        "Google Ads",
        "Analytics",
     ],
     correctAnswer:"AdMob",
      
    },
     {
      id: 10,
      question:"What is a single screen in an Android app called?",
     options:[
         "Window",
        " Page",
        "Frame",
        " Activity",
     ],
     correctAnswer:" Activity",
      
    },
   ],
    "ios-apps": [
{
    id: 1,
    question: "Which programming language is mainly used to build iOS apps today?",
    options: [
      "Java",
      "Kotlin",
      "Swift",
      "Python",
    ],
    correctAnswer: "Swift",
  },
  {
    id: 2,
    question: "What is the official IDE for iOS app development?",
    options: [
      "Android Studio",
      "Xcode",
      "Visual Studio",
      "IntelliJ",
    ],
    correctAnswer: "Xcode",
  },
  {
    id: 3,
    question: "Which company develops the iOS operating system?",
    options: [
      "Google",
      "Microsoft",
      "Apple",
      "Samsung",
    ],
    correctAnswer: "Apple",
  },
  {
    id: 4,
    question: "Before Swift, which language was mainly used for iOS development?",
    options: [
      "C++",
      "Objective-C",
      "Ruby",
      "C#",
    ],
    correctAnswer: "Objective-C",
  },
  {
    id: 5,
    question: "What is the store called where iOS apps are published?",
    options: [
      "Play Store",
      "App Store",
      "Microsoft Store",
      "Galaxy Store",
    ],
    correctAnswer: "App Store",
  },
  {
    id: 6,
    question: "What is the annual fee for an Apple Developer Program membership?",
    options: [
      "$25",
      "$99",
      "Free",
      "$199",
    ],
    correctAnswer: "$99",
  },
  {
    id: 7,
    question: "Which modern framework is used to build user interfaces in iOS declaratively?",
    options: [
      "SwiftUI",
      "UIKit",
      "React",
      "Flutter",
    ],
    correctAnswer: "SwiftUI",
  },
  {
    id: 8,
    question: "On which operating system must Xcode be run?",
    options: [
      "Windows",
      "Linux",
      "macOS",
      "Ubuntu",
    ],
    correctAnswer: "macOS",
  },
  {
    id: 9,
    question: "What is the file format used to distribute and install iOS apps?",
    options: [
      ".apk",
      ".exe",
      ".ipa",
      ".dmg",
    ],
    correctAnswer: ".ipa",
  },
  {
    id: 10,
    question: "Which Apple framework is used to show ads inside iOS apps?",
    options: [
      "AdMob",
      "iAd",
      "AdSense",
      "Analytics",
    ],
    correctAnswer: "iAd",
  },
   ],
 " web-games": [
  {
    id: 1,
    question: "Which HTML element is mainly used to draw 2D graphics for web games?",
    options: [
      "<div>",
      "<canvas>",
      "<svg>",
      "<video>",
    ],
    correctAnswer: "<canvas>",
  },
  {
    id: 2,
    question: "Which programming language runs games directly in the browser?",
    options: [
      "Python",
      "Java",
      "JavaScript",
      "C#",
    ],
    correctAnswer: "JavaScript",
  },
  {
    id: 3,
    question: "Which API is used for high performance 3D graphics in the browser?",
    options: [
      "WebGL",
      "WebRTC",
      "WebSocket",
      "WebASM",
    ],
    correctAnswer: "WebGL",
  },
  {
    id: 4,
    question: "Which popular JavaScript library is used to create 3D games on the web?",
    options: [
      "jQuery",
      "Three.js",
      "Lodash",
      "Axios",
    ],
    correctAnswer: "Three.js",
  },
  {
    id: 5,
    question: "Which game engine is well known for exporting games to HTML5?",
    options: [
      "Unity",
      "CryEngine",
      "Source",
      "RenderWare",
    ],
    correctAnswer: "Unity",
  },
  {
    id: 6,
    question: "Which JavaScript method is commonly used to create smooth game animations?",
    options: [
      "setInterval",
      "requestAnimationFrame",
      "setTimeout",
      "addEventListener",
    ],
    correctAnswer: "requestAnimationFrame",
  },
  {
    id: 7,
    question: "Which technology enables real time multiplayer communication in web games?",
    options: [
      "WebSocket",
      "FTP",
      "SMTP",
      "REST",
    ],
    correctAnswer: "WebSocket",
  },
  {
    id: 8,
    question: "Which 2D framework is popular for building HTML5 browser games?",
    options: [
      "Phaser",
      "Bootstrap",
      "Tailwind",
      "Express",
    ],
    correctAnswer: "Phaser",
  },
  {
    id: 9,
    question: "Where is a web game's player progress often saved in the browser?",
    options: [
      "RAM",
      "localStorage",
      "Cache only",
      "Cookies file",
    ],
    correctAnswer: "localStorage",
  },
  {
    id: 10,
    question: "Which technology lets browsers run code at near native speed for games?",
    options: [
      "WebAssembly",
      "AJAX",
      "JSON",
      "XML",
    ],
    correctAnswer: "WebAssembly",
  },
],
 "mobile-games" : [
  {
    id: 1,
    question: "Which game engine is most popular for building mobile games?",
    options: [
      "Unity",
      "WordPress",
      "Laravel",
      "Django",
    ],
    correctAnswer: "Unity",
  },
  {
    id: 2,
    question: "Which programming language is mainly used in the Unity game engine?",
    options: [
      "Java",
      "C#",
      "Python",
      "Swift",
    ],
    correctAnswer: "C#",
  },
  {
    id: 3,
    question: "Which engine is known for high-end 3D mobile games and uses Blueprints?",
    options: [
      "Unreal Engine",
      "Godot",
      "GameMaker",
      "Construct",
    ],
    correctAnswer: "Unreal Engine",
  },
  {
    id: 4,
    question: "Which store is used to publish Android mobile games?",
    options: [
      "App Store",
      "Google Play Store",
      "Microsoft Store",
      "Steam",
    ],
    correctAnswer: "Google Play Store",
  },
  {
    id: 5,
    question: "Which platform is used to publish iOS mobile games?",
    options: [
      "Play Store",
      "App Store",
      "Galaxy Store",
      "Epic Store",
    ],
    correctAnswer: "App Store",
  },
  {
    id: 6,
    question: "Which Google platform is commonly used to show ads in mobile games?",
    options: [
      "AdSense",
      "AdMob",
      "Analytics",
      "Firebase Auth",
    ],
    correctAnswer: "AdMob",
  },
  {
    id: 7,
    question: "What is the name of the per second image refresh rate in games?",
    options: [
      "DPI",
      "FPS",
      "PPI",
      "Hz Count",
    ],
    correctAnswer: "FPS",
  },
  {
    id: 8,
    question: "Which free and open-source engine is popular for 2D mobile games?",
    options: [
      "Godot",
      "Photoshop",
      "Blender",
      "Maya",
    ],
    correctAnswer: "Godot",
  },
  {
    id: 9,
    question: "What is a common revenue model where a game is free but sells items?",
    options: [
      "Premium",
      "Freemium",
      "Subscription only",
      "Open source",
    ],
    correctAnswer: "Freemium",
  },
  {
    id: 10,
    question: "Which tool is widely used to create 3D models for mobile games?",
    options: [
      "Blender",
      "Excel",
      "Notepad",
      "Postman",
    ],
    correctAnswer: "Blender",
  },
],
"minecraft-game" : [
  {
    id: 1,
    question: "Which company currently owns Minecraft?",
    options: [
      "Sony",
      "Microsoft",
      "Nintendo",
      "Google",
    ],
    correctAnswer: "Microsoft",
  },
  {
    id: 2,
    question: "Who is the original creator of Minecraft?",
    options: [
      "Markus Persson (Notch)",
      "Hideo Kojima",
      "Shigeru Miyamoto",
      "Gabe Newell",
    ],
    correctAnswer: "Markus Persson (Notch)",
  },
  {
    id: 3,
    question: "What is the main hostile creature that explodes near the player?",
    options: [
      "Zombie",
      "Creeper",
      "Skeleton",
      "Enderman",
    ],
    correctAnswer: "Creeper",
  },
  {
    id: 4,
    question: "What shape are most blocks in Minecraft?",
    options: [
      "Sphere",
      "Cube",
      "Pyramid",
      "Cylinder",
    ],
    correctAnswer: "Cube",
  },
  {
    id: 5,
    question: "Which rare ore is used to craft the strongest tools and armor?",
    options: [
      "Iron",
      "Gold",
      "Diamond",
      "Coal",
    ],
    correctAnswer: "Diamond",
  },
  {
    id: 6,
    question: "What is the dangerous dimension reached through an obsidian portal?",
    options: [
      "The End",
      "The Nether",
      "The Void",
      "The Overworld",
    ],
    correctAnswer: "The Nether",
  },
  {
    id: 7,
    question: "Which final boss must be defeated in 'The End' dimension?",
    options: [
      "Wither",
      "Ender Dragon",
      "Warden",
      "Elder Guardian",
    ],
    correctAnswer: "Ender Dragon",
  },
  {
    id: 8,
    question: "What do you use to mine stone and harder blocks?",
    options: [
      "Axe",
      "Shovel",
      "Pickaxe",
      "Hoe",
    ],
    correctAnswer: "Pickaxe",
  },
  {
    id: 9,
    question: "What is the tall, black creature that teleports called?",
    options: [
      "Enderman",
      "Ghast",
      "Blaze",
      "Phantom",
    ],
    correctAnswer: "Enderman",
  },
  {
    id: 10,
    question: "Which game mode lets players build freely with unlimited resources?",
    options: [
      "Survival",
      "Hardcore",
      "Adventure",
      "Creative",
    ],
    correctAnswer: "Creative",
  },
],
"shareit-app" : [
  {
    id: 1,
    question: "What is the main purpose of the SHAREit app?",
    options: [
      "Video calling",
      "File sharing",
      "Online shopping",
      "Web browsing",
    ],
    correctAnswer: "File sharing",
  },
  {
    id: 2,
    question: "Which technology does SHAREit mainly use to transfer files between devices?",
    options: [
      "Mobile data",
      "Wi-Fi Direct",
      "Email",
      "Bluetooth only",
    ],
    correctAnswer: "Wi-Fi Direct",
  },
  {
    id: 3,
    question: "What is a key advantage of SHAREit over Bluetooth for transfers?",
    options: [
      "Lower quality",
      "Much faster speed",
      "Needs internet",
      "Smaller files only",
    ],
    correctAnswer: "Much faster speed",
  },
  {
    id: 4,
    question: "Is an internet connection required to share files using SHAREit?",
    options: [
      "Yes, always",
      "No, it works offline",
      "Only Wi-Fi internet",
      "Only mobile data",
    ],
    correctAnswer: "No, it works offline",
  },
  {
    id: 5,
    question: "Which company originally developed SHAREit?",
    options: [
      "Lenovo",
      "Samsung",
      "Xiaomi",
      "Google",
    ],
    correctAnswer: "Lenovo",
  },
  {
    id: 6,
    question: "Which of these can be transferred using SHAREit?",
    options: [
      "Only photos",
      "Only music",
      "Apps, photos, videos and more",
      "Only documents",
    ],
    correctAnswer: "Apps, photos, videos and more",
  },
  {
    id: 7,
    question: "On which platforms is SHAREit available?",
    options: [
      "Android only",
      "iOS only",
      "Android, iOS, Windows and more",
      "Windows only",
    ],
    correctAnswer: "Android, iOS, Windows and more",
  },
  {
    id: 8,
    question: "How does the receiver usually connect in SHAREit to start a transfer?",
    options: [
      "By scanning a QR code",
      "By entering an email",
      "By calling the sender",
      "By using a password only",
    ],
    correctAnswer: "By scanning a QR code",
  },
  {
    id: 9,
    question: "In which country was SHAREit's parent company founded?",
    options: [
      "USA",
      "China",
      "Japan",
      "South Korea",
    ],
    correctAnswer: "China",
  },
  {
    id: 10,
    question: "Besides file sharing, what extra feature does SHAREit also offer?",
    options: [
      "Video and music streaming",
      "Food delivery",
      "Ride booking",
      "Stock trading",
    ],
    correctAnswer: "Video and music streaming",
  },
],
"file-sharing" : [
  {
    id: 1,
    question: "Which short-range wireless technology is commonly used to share files between nearby phones?",
    options: [
      "Bluetooth",
      "GPS",
      "NFC payment",
      "Infrared TV",
    ],
    correctAnswer: "Bluetooth",
  },
  {
    id: 2,
    question: "What does the abbreviation 'FTP' stand for in file sharing?",
    options: [
      "Fast Transfer Protocol",
      "File Transfer Protocol",
      "Free Transfer Program",
      "File Type Process",
    ],
    correctAnswer: "File Transfer Protocol",
  },
  {
    id: 3,
    question: "Which Google service is widely used for cloud-based file storage and sharing?",
    options: [
      "Google Drive",
      "Google Maps",
      "Google Pay",
      "Google Photos",
    ],
    correctAnswer: "Google Drive",
  },
  {
    id: 4,
    question: "What is the name of the popular peer-to-peer protocol for sharing large files?",
    options: [
      "BitTorrent",
      "HTTP",
      "SMTP",
      "DNS",
    ],
    correctAnswer: "BitTorrent",
  },
  {
    id: 5,
    question: "Which Apple feature lets you wirelessly share files between iPhones and Macs?",
    options: [
      "AirDrop",
      "FaceTime",
      "iCloud Lock",
      "Siri",
    ],
    correctAnswer: "AirDrop",
  },
  {
    id: 6,
    question: "What is a common term for storing and accessing files over the internet?",
    options: [
      "Cloud storage",
      "Local disk",
      "RAM storage",
      "Cache only",
    ],
    correctAnswer: "Cloud storage",
  },
  {
    id: 7,
    question: "Which file format is most commonly used to compress multiple files into one for sharing?",
    options: [
      ".zip",
      ".txt",
      ".mp3",
      ".html",
    ],
    correctAnswer: ".zip",
  },
  {
    id: 8,
    question: "What does 'P2P' stand for in file sharing?",
    options: [
      "Phone to Phone",
      "Peer to Peer",
      "Public to Private",
      "Path to Port",
    ],
    correctAnswer: "Peer to Peer",
  },
  {
    id: 9,
    question: "Which of these is a popular cloud service by Microsoft for file sharing?",
    options: [
      "OneDrive",
      "Dropbox",
      "Mega",
      "iCloud",
    ],
    correctAnswer: "OneDrive",
  },
  {
    id: 10,
    question: "What should you check to keep shared files safe from unauthorized access?",
    options: [
      "File color",
      "Sharing permissions",
      "File name length",
      "Screen brightness",
    ],
    correctAnswer: "Sharing permissions",
  },
],
 "cyber-security" : [
  {
    id: 1,
    question: "What is a fake email or message that tricks people into giving personal information called?",
    options: [
      "Phishing",
      "Caching",
      "Pinging",
      "Hosting",
    ],
    correctAnswer: "Phishing",
  },
  {
    id: 2,
    question: "What is malicious software designed to harm or exploit a device called?",
    options: [
      "Hardware",
      "Malware",
      "Firmware",
      "Freeware",
    ],
    correctAnswer: "Malware",
  },
  {
    id: 3,
    question: "Which type of attack locks your files and demands payment to unlock them?",
    options: [
      "Adware",
      "Spyware",
      "Ransomware",
      "Browser cache",
    ],
    correctAnswer: "Ransomware",
  },
  {
    id: 4,
    question: "What is the best practice for creating a secure password?",
    options: [
      "Use '123456'",
      "Use your name",
      "Use a long mix of letters, numbers and symbols",
      "Use 'password'",
    ],
    correctAnswer: "Use a long mix of letters, numbers and symbols",
  },
  {
    id: 5,
    question: "What does '2FA' stand for in cyber security?",
    options: [
      "Two-Factor Authentication",
      "Two-File Access",
      "Twice-Fast Action",
      "Two-Forward Address",
    ],
    correctAnswer: "Two-Factor Authentication",
  },
  {
    id: 6,
    question: "Which tool helps block unauthorized access to a network?",
    options: [
      "Firewall",
      "Keyboard",
      "Webcam",
      "Speaker",
    ],
    correctAnswer: "Firewall",
  },
  {
    id: 7,
    question: "What does 'VPN' stand for?",
    options: [
      "Virtual Private Network",
      "Verified Public Node",
      "Visual Personal Network",
      "Virtual Public Name",
    ],
    correctAnswer: "Virtual Private Network",
  },
  {
    id: 8,
    question: "What does the 'https' in a website URL indicate?",
    options: [
      "A faster website",
      "A secure, encrypted connection",
      "A free website",
      "A gaming website",
    ],
    correctAnswer: "A secure, encrypted connection",
  },
  {
    id: 9,
    question: "What is a person who illegally breaks into computer systems called?",
    options: [
      "Hacker",
      "Designer",
      "Blogger",
      "Gamer",
    ],
    correctAnswer: "Hacker",
  },
  {
    id: 10,
    question: "What is the safest action when you receive a link from an unknown sender?",
    options: [
      "Click it immediately",
      "Share it with friends",
      "Avoid clicking and delete it",
      "Reply with your password",
    ],
    correctAnswer: "Avoid clicking and delete it",
  },
],
 "ai-quiz": [
  {
    id: 1,
    question: "What does 'AI' stand for?",
    options: [
      "Automatic Internet",
      "Artificial Intelligence",
      "Advanced Information",
      "Applied Internet",
    ],
    correctAnswer: "Artificial Intelligence",
  },
  {
    id: 2,
    question: "Which subfield of AI allows computers to learn from data without being explicitly programmed?",
    options: [
      "Machine Learning",
      "Web Hosting",
      "Data Entry",
      "Networking",
    ],
    correctAnswer: "Machine Learning",
  },
  {
    id: 3,
    question: "Which popular AI chatbot was developed by OpenAI?",
    options: [
      "ChatGPT",
      "Photoshop",
      "Excel",
      "Notepad",
    ],
    correctAnswer: "ChatGPT",
  },
  {
    id: 4,
    question: "What is the AI assistant developed by Anthropic called?",
    options: [
      "Alexa",
      "Claude",
      "Cortana",
      "Bixby",
    ],
    correctAnswer: "Claude",
  },
  {
    id: 5,
    question: "Which technology helps AI understand and process human language?",
    options: [
      "NLP (Natural Language Processing)",
      "HTML",
      "FTP",
      "CSS",
    ],
    correctAnswer: "NLP (Natural Language Processing)",
  },
  {
    id: 6,
    question: "What is a 'neural network' in AI inspired by?",
    options: [
      "The human brain",
      "A car engine",
      "A water pipe",
      "A telephone line",
    ],
    correctAnswer: "The human brain",
  },
  {
    id: 7,
    question: "What is AI that can generate text, images and music called?",
    options: [
      "Generative AI",
      "Static AI",
      "Manual AI",
      "Offline AI",
    ],
    correctAnswer: "Generative AI",
  },
  {
    id: 8,
    question: "Which company developed the Gemini AI model?",
    options: [
      "Google",
      "Apple",
      "Sony",
      "IBM",
    ],
    correctAnswer: "Google",
  },
  {
    id: 9,
    question: "What is the term for an incorrect or made-up answer given by an AI?",
    options: [
      "Hallucination",
      "Calculation",
      "Compilation",
      "Optimization",
    ],
    correctAnswer: "Hallucination",
  },
  {
    id: 10,
    question: "Which of these is a common real-world use of AI?",
    options: [
      "Voice assistants",
      "Manual typing",
      "Paper printing",
      "Plugging cables",
    ],
    correctAnswer: "Voice assistants",
  },
],

  "general-knowledge": [
    {
      id: 1,
     question:"What is the capital of India?",
     options:[
         "Mumbai",
        "New Delhi",
        "Kolkata",
        "Chennai",
     ],
     correctAnswer:"New Delhi",
    },
    {
      id: 2,
      question:"Which planet is known as the Red Planet?",
     options:[
         "Earth",
        "Venus",
        "Mars",
        "Jupiter",
     ],
     correctAnswer:"Mars",
      
    },
     {
      id: 3,
      question:"Who wrote the play Romeo and Juliet?",
     options:[
         "Charles Dickens",
        "William Shakespeare",
        "Jane Austen",
        "Mark Twain",
     ],
     correctAnswer:"William Shakespeare",
      
    },
     {
      id: 4,
      question:"What is the largest ocean on Earth?",
     options:[
         "Atlantic Ocean",
        "Indian Ocean",
        "Arctic Ocean",
        "Pacific Ocean",

     ],
     correctAnswer:"Pacific Ocean",
      
    },
     {
      id: 5,
      question:"Which gas do plants absorb from the atmosphere?",
     options:[
         "Oxygen",
        "Carbon Dioxide",
        "Nitrogen",
        "Hydrogen",
     ],
     correctAnswer:"Carbon Dioxide",
      
    },
     {
      id: 6,
      question:"Who is known as the Father of the Nation in India?",
     options:[
         "Jawaharlal Nehru",
        "Mahatma Gandhi",
        "Subhas Chandra Bose",
        "Sardar Patel",
     ],
     correctAnswer:"Mahatma Gandhi",
      
    },
     {
      id: 7,
      question:"Which is the smallest continent in the world?",
     options:[
         "Europe",
        "Australia",
        "Antarctica",
        "South America",
     ],
     correctAnswer:"Australia",
      
    },
     {
      id: 8,
      question:"What is the boiling point of water?",
     options:[
         "90°C",
        "80°C",
        "100°C",
        "70°C",
     ],
     correctAnswer:"100°C",
      
    },
     {
      id: 9,
      question:"Which animal is known as the King of the Jungle?",
     options:[
         "Tiger",
        "Lion",
        "Elephant",
        "Giraffe",
     ],
     correctAnswer:"Lion",
      
    },
     {
      id: 10,
      question:"Which country is famous for the Great Wall?",
     options:[
         "India",
        "China",
        "Japan",
        "South Korea",
     ],
     correctAnswer:"China",
      
    },
  ],
  cricket: [
    {
      id: 1,
      question: "Who is known as the God of Cricket?",
      options: [
        "Virat Kohli",
        "Sachin Tendulkar",
        "MS Dhoni",
        "Ricky Ponting",
      ],
      correctAnswer: "Sachin Tendulkar",
    },
    {
      id: 2,
      question: "How many players in a cricket team?",
      options: ["9", "10", "11", "12"],
      correctAnswer: "11",
    },
     {
      id: 3,
      question:"Which country won the first ICC Cricket World Cup in 1975?",
     options:[
         "India",
        "Pakistan",
        "England",
        "West Indies",
     ],
     correctAnswer:"West Indies",
      
    },
     {
      id: 4,
      question:"What is the maximum number of overs in a One Day International (ODI) match per team?",
     options:[
         "20",
        "30",
        "50",
        "100",
     ],
     correctAnswer:"50",
      
    },
     {
      id: 5,
      question:"Who is known as Captain Cool in cricket?",
     options:[
         "Sachin Tendulkar",
        "MS Dhoni",
        "Ricky Ponting",
        "Brian Lara",
     ],
     correctAnswer:"MS Dhoni",
      
    },
     {
      id: 6,
      question:"Which country is known as the birthplace of cricket?",
     options:[
         "India",
        "Pakistan",
        "England",
        "West Indies",
     ],
     correctAnswer:"England",
      
    },
     {
      id: 7,
      question:"What is it called when a bowler takes three wickets in three consecutive balls?",
     options:[
         "Triple",
        "Hattrick",
        "Super Over",
        "Yorker",
     ],
     correctAnswer:"Hattrick",
      
    },
     {
      id: 8,
      question:"Which Indian player is known as the Hitman?",
     options:[
         "Virat Kohli",
        "Rishabh Pant",
        "Shikhar Dhawan",
        "Rohit Sharma",
     ],
     correctAnswer:"Rohit Sharma",
      
    },
     {
      id: 9,
      question:"How many runs are awarded for a ball hit over the boundary without touching the ground?",
     options:[
         "4",
        "6",
        "2",
        "8",
     ],
     correctAnswer:"6",
      
    },
     {
      id: 10,
      question:"What does LBW stand for?",
     options:[
         "Leg Before Wicket",
        "Long Bat Win",
        "Leg By Win",
        "Left Ball Wide",
     ],
     correctAnswer:"Leg Before Wicket",
      
    },
  ],

  bollywood: [
    {
      id: 1,
      question: "Who is called King Khan?",
      options: [
        "Salman Khan",
        "Aamir Khan",
        "Shah Rukh Khan",
        "Saif Ali Khan",
      ],
      correctAnswer: "Shah Rukh Khan",
    },
      {
      id: 2,
      question:"Which Bollywood movie features the character Raj played by Shah Rukh Khan?",
     options:[
         "Kabhi Khushi Kabhi Gam",
        "Dilwale Dulhania Le Jayenge",
        "Kuch Kuch Hota Hai",
        "Devdas",
     ],
     correctAnswer:"Dilwale Dulhania Le Jayenge",
      
    },
     {
      id: 3,
      question:"Who directed the movie Lagaan?",
     options:[
         "Karan Johar",
        "Sanjay Leela Bhansali",
        "Ashutosh Gowariker",
        "Rohit Shetty",
     ],
     correctAnswer:"Ashutosh Gowariker",
      
    },
     {
      id: 4,
      question:"Which actress is known as the Queen of Bollywood?",
     options:[
         "Deepika Padukone",
        "Alia Bhatt",
        "Kangana Ranaut",
        "Katrina Kaif",
     ],
     correctAnswer:"Kangana Ranaut",
      
    },
     {
      id: 5,
      question:"In which movie did Aamir Khan play the role of a wrestler?",
     options:[
         "PK",
        "Dangal",
        "3 Idiots",
        "Ghajini",
     ],
     correctAnswer:"Dangal",
      
    },
     {
      id: 6,
      question:"Which Bollywood film is based on cricket and stars Aamir Khan?",
     options:[
         "Chak De! India",
        "Lagaan",
        "MS Dhoni: The Untold Story",
        "Sultan",
     ],
     correctAnswer:"Lagaan",
      
    },
     {
      id: 7,
      question:"Who composed the music for the movie Dil Se?",
     options:[
         "Pritam",
        "A.R. Rahman",
        "Vishal-Shekhar",
        "Anu Malik",
     ],
     correctAnswer:"A.R. Rahman",
      
    },
     {
      id: 8,
      question:"Which movie features the famous dialogue Mogambo Khush Hua?",
     options:[
         "Sholay",
        "Mr. India",
        "Don",
        "Deewaar",
     ],
     correctAnswer:"Mr. India",
      
    },
     {
      id: 9,
      question:"Who played the role of Gabbar Singh in Sholay?",
     options:[
         "Amjad Khan",
        "Dharmendra",
        "Amitabh Bachchan",
        "Sanjeev Kumar",
     ],
     correctAnswer:"Amjad Khan",
      
    },
     {
      id: 10,
      question:"Which Bollywood movie won the Oscar for Best Original Song Jai Ho?",
     options:[
         "Rang De Basanti",
        "Slumdog Millionaire",
        "Swades",
        "Rockstar",
     ],
     correctAnswer:"Slumdog Millionaire",
      
    },
  ],
  history: [
     {
      id: 1,
      question:"Who was the first President of the United States?",
     options:[
         "Abraham Lincoln",
        "George Washington",
        "Thomas Jefferson",
        "John Adams",
     ],
     correctAnswer:"George Washington",
      
    },
     {
      id: 2,
      question:"In which year did India gain independence?",
     options:[
         "1945",
        "1946",
        "1947",
        "1950",
     ],
     correctAnswer:"1947",
      
    },
     {
      id: 3,
      question:"Who was the first Emperor of the Maurya Empire?",
     options:[
         "Ashoka",
        "Chandragupta Maurya",
        "Bindusara",
        "Harsha",
     ],
     correctAnswer:"Chandragupta Maurya",
      
    },
     {
      id: 4,
      question:"The French Revolution began in which year?",
     options:[
         "1776",
        "1789",
        "1791",
        "1793",
     ],
     correctAnswer:"1789",
      
    },
     {
      id: 5,
      question:"Who was known as the Iron Man of India?",
     options:[
         "Jawaharlal Nehru",
        "Subhas Chandra Bose",
        "Sardar Vallabhbhai Patel",
        "Bhagat Singh",
     ],
     correctAnswer:"Sardar Vallabhbhai Patel",
      
    },
     {
      id: 6,
      question:"Which war was fought between the North and South regions of the United States?",
     options:[
         "World War I",
        "American Civil War",
        "Cold War",
        "Vietnam War",
     ],
     correctAnswer:"American Civil War",
      
    },
     {
      id: 7,
      question:"Who discovered America in 1492?",
     options:[
         "Vasco da Gama",
        "Ferdinand Magellan",
        "Christopher Columbus",
        "James Cook",
     ],
     correctAnswer:"Christopher Columbus",
      
    },
     {
      id: 8,
      question:"The World War II ended in which year?",
     options:[
         "1942",
        "1945",
        "1947",
        "1950",
     ],
     correctAnswer:"1945",
      
    },
     {
      id: 9,
      question:"Who was the founder of the Mughal Empire in India?",
     options:[
         "Akbar",
        "Shah Jahan",
        "Babur",
        "Humayun",
     ],
     correctAnswer:"Babur",
      
    },
     {
      id: 10,
      question:"The famous monument Taj Mahal was built by which Mughal emperor?",
     options:[
         "Akbar",
        "Jahangir",
        "Shah Jahan",
        "Aurangzeb",
     ],
     correctAnswer:"Shah Jahan",
      
    },
],
  business: [
     {
      id: 1,
      question:"Who is the founder of Amazon?",
     options:[
        "Bill Gates",
        "Steve Jobs",
        "Jeff Bezos",
        "Elon Musk",
     ],
     correctAnswer:"Jeff Bezos",
      
    },
     {
      id: 2,
      question:"Which company is known for the iPhone?",
     options:[
         "Samsung",
        "Apple",
        "Google",
        "Microsoft",
     ],
     correctAnswer:"Apple",
      
    },
     {
      id: 3,
      question:"What does CEO stand for?",
     options:[
         "Chief Executive Officer",
        "Central Executive Officer",
        "Chief Economic Officer",
        "Corporate Executive Officer",
     ],
     correctAnswer:"Chief Executive Officer",
      
    },
     {
      id: 4,
      question:"Which Indian company is famous for its IT services and consulting?",
     options:[
        "Reliance Industries",
        "TCS",
        "Infosys",
        "Wipro",
     ],
     correctAnswer:"TCS",
      
    },
     {
      id: 5,
      question:"Who is the founder of Tesla?",
     options:[
         "Elon Musk",
        "Nikola Tesla",
        "Jeff Bezos",
        "Larry Page",
     ],
     correctAnswer:"Elon Musk",
      
    },
     {
      id: 6,
      question:"What does IPO stand for in business?",
     options:[
         "Initial Public Offering",
        "International Product Order",
        "Internal Public Operation",
        "Initial Private Offering",
     ],
     correctAnswer:"Initial Public Offering",
      
    },
     {
      id: 7,
      question:"Which company owns YouTube?",
     options:[
         "Meta",
        "Amazon",
        "Google",
        "Microsoft",
     ],
     correctAnswer:"Google",
      
    },
     {
      id: 8,
      question:"Which Indian businessman is the chairman of Reliance Industries?",
     options:[
         "Ratan Tata",
        "Mukesh Ambani",
        "Gautam Adani",
        "Anand Mahindra",
     ],
     correctAnswer:"Mukesh Ambani",
      
    },
     {
      id: 9,
      question:"What does GDP stand for?",
     options:[
         "Gross Domestic Product",
        "General Development Plan",
        "Global Distribution Program",
        "Government Development Project",
     ],
     correctAnswer:"Gross Domestic Product",
      
    },
     {
      id: 10,
      question:"Which company is known for the Windows operating system?",
     options:[
         "Apple",
        "IBM",
        "Microsoft",
        "Intel",
     ],
     correctAnswer:"Microsoft",
      
    },
],
  technology: [
     {
      id: 1,
      question:"What does CPU stand for?",
     options:[
         "Central Process Unit",
        "Central Processing Unit",
        "Computer Personal Unit",
        "Central Power Unit",
     ],
     correctAnswer:"Central Processing Unit",
      
    },
     {
      id: 2,
      question:"Which company developed the Windows operating system?",
     options:[
         "Apple",
        "IBM",
        "Microsoft",
        "Google",
     ],
     correctAnswer:"Microsoft",
      
    },
     {
      id: 3,
      question:"What does HTML stand for?",
     options:[
         "Hyper Trainer Marking Language",
        "Hyper Text Marketing Language",
        "Hyper Text Markup Language",
        "High Text Markup Language",
     ],
     correctAnswer:"Hyper Text Markup Language",
      
    },
     {
      id: 4,
      question:"Which device is used to connect computers over the internet?",
     options:[
         "Monitor",
        "Keyboard",
        "Router",
        "Printer",
     ],
     correctAnswer:"Router",
      
    },
     {
      id: 5,
      question:"Which company developed the Android operating system?",
     options:[
         "Apple",
        "Google",
        "Microsoft",
        "Amazon",
     ],
     correctAnswer:"Google",
      
    },
     {
      id: 6,
      question:"What does RAM stand for?",
     options:[
         "Random Access Memory",
        "Read Access Memory",
        "Run Access Memory",
        "Rapid Access Memory",
     ],
     correctAnswer:"Random Access Memory",
      
    },
     {
      id: 7,
      question:"Which programming language is mainly used for web page styling?",
     options:[
         "Python",
        "Java",
        "C++",
        "CSS",
     ],
     correctAnswer:"CSS",
      
    },
     {
      id: 8,
      question:"What does URL stand for?",
     options:[
         "Uniform Resource Locator",
        "Universal Resource Locator",
        "Unique Resource Locator",
        "Unified Resource Locator",
     ],
     correctAnswer:"Uniform Resource Locator",
      
    },
     {
      id: 9,
      question:"Which company created the iPhone?",
     options:[
         "Samsung",
        "Apple",
        "Nokia",
        "Sony",
     ],
     correctAnswer:"Apple",
      
    },
     {
      id: 10,
      question:"What is the brain of the computer?",
     options:[
         "Monitor",
        "Keyboard",
        "CPU",
        "Printer",
     ],
     correctAnswer:"CPU",
      
    },
],
  music: [
     {
      id: 1,
      question:"Who composed the song Tum Hi Ho from Aashiqui 2?",
     options:[
         "Pritam",
        "Vishal-Shekhar",
        "Mithoon",
        "A.R. Rahman",
     ],
     correctAnswer:"Mithoon",
      
    },
     {
      id: 2,
      question:"Who is the singer of Kal Ho Naa Ho title track from Kal Ho Naa Ho?",
     options:[
         "Arijit Singh",
        "Sonu Nigam",
        "KK",
        "Udit Narayan",
     ],
     correctAnswer:"Sonu Nigam",
      
    },
     {
      id: 3,
      question:"Who sang the song Chaiyya Chaiyya from Dil Se?",
     options:[
         "Arijit Singh",
        "Sukhwinder Singh",
        "Lata Mangeshkar",
        "Mohit Chauhan",
     ],
     correctAnswer:"Sukhwinder Singh",
      
    },
     {
      id: 4,
      question:"Which composer created the music for Dilwale Dulhania Le Jayenge?",
     options:[
         "Jatin-Lalit",
        "Pritam",
        "Anu Malik",
        "Shankar-Ehsaan-Loy",
     ],
     correctAnswer:"Jatin-Lalit",
      
    },
     {
      id: 5,
      question:"Which singer is known as the Melody King of Bollywood?",
     options:[
         "Arijit Singh",
        "Sonu Nigam",
        "KK",
        "Udit Narayan",
     ],
     correctAnswer:"Arijit Singh",
      
    },
     {
      id: 6,
      question:"Who composed the music for Rockstar?",
     options:[
         "Pritam",
        "Shankar-Ehsaan-Loy",
        "Vishal-Shekhar",
        "A. R. Rahman",
     ],
     correctAnswer:"A. R. Rahman",
      
    },
     {
      id: 7,
      question:"Which singer sang Kesariya from Brahmāstra: Part One – Shiva?",
     options:[
         "Armaan Malik",
        "Arijit Singh",
        "Jubin Nautiyal",
        "Sonu Nigam",
     ],
     correctAnswer:"Arijit Singh",
      
    },
     {
      id: 8,
      question:"Who is known as the Nightingale of India?",
     options:[
         "Shreya Ghoshal",
        "Lata Mangeshkar",
        "Asha Bhosle",
        "Alka Yagnik",
     ],
     correctAnswer:"Lata Mangeshkar",
      
    },
     {
      id: 9,
      question:"Which singer sang Tujh Mein Rab Dikhta Hai from Rab Ne Bana Di Jodi?",
     options:[
         "Sonu Nigam",
        "Arijit Singh",
        "Roop Kumar Rathod",
        "Udit Narayan",
     ],
     correctAnswer:"Roop Kumar Rathod",
      
    },
     {
      id: 10,
      question:"Who composed the music for Kabir Singh?",
     options:[
         "A.R. Rahman",
        "Pritam",
        "Mithoon",
        "Multiple composers",
     ],
     correctAnswer:"Multiple composers",
      
    },
],

  science: [
    {
      id: 1,
      question: "Water chemical formula?",
      options: ["CO2", "H2O", "O2", "NaCl"],
      correctAnswer: "H2O",
    },
     {
      id: 2,
      question:"Which planet is closest to the Sun?",
     options:[
         "Venus",
        "Earth",
        "Mercury",
        "Mars",
     ],
     correctAnswer:"Mercury",
      
    },
     {
      id: 3,
      question:"What gas do humans need to breathe to survive?",
     options:[
         "Nitrogen",
        "Carbon Dioxide",
        "Oxygen",
        "Hydrogen",
     ],
     correctAnswer:"Oxygen",
      
    },
     {
      id: 4,
      question:"What is the powerhouse of the cell?",
     options:[
         "Nucleus",
        "Mitochondria",
        "Cytoplasm",
        "Ribosome",
     ],
     correctAnswer:"Mitochondria",
      
    },
     {
      id: 5,
      question:"Which scientist developed the Theory of Relativity?",
     options:[
         "Isaac Newton",
        "Galileo Galilei",
        "Nikola Tesla",
        "Albert Einstein",
     ],
     correctAnswer:"Albert Einstein",
      
    },
     {
      id: 6,
      question:"Which part of the plant conducts photosynthesis?",
     options:[
         "Root",
        "Stem",
        "Leaf",
        "Flower",
     ],
     correctAnswer:"Leaf",
      
    },
     {
      id: 7,
      question:"What is the boiling point of water at sea level?",
     options:[
         "90°C",
        "95°C",
        "100°C",
        "110°C",
     ],
     correctAnswer:"100°C",
      
    },
     {
      id: 8,
      question:"Which vitamin is mainly obtained from sunlight?",
     options:[
         "Vitamin A",
        "Vitamin B",
        "Vitamin C",
        "Vitamin D",
     ],
     correctAnswer:"Vitamin D",
      
    },
     {
      id: 9,
      question:"Which force keeps planets moving around the Sun?",
     options:[
         "Magnetic Force",
        "Frictional Force",
        "Gravitational Force",
        "Nuclear Force",
     ],
     correctAnswer:"Gravitational Force",
      
    },
     {
      id: 10,
      question:"What is the hardest natural substance on Earth?",
     options:[
         "Gold",
        "Iron",
        "Diamond",
        "Silver",
     ],
     correctAnswer:"Diamond",
      
    },
  ],
    book: [
    {
      id: 1,
      question:"Who wrote Harry Potter and the Philosopher's Stone?",
     options:[
         "J.R.R. Tolkien",
        "J.K. Rowling",
        "Stephen King",
        "George Orwell",
     ],
     correctAnswer:"J.K. Rowling",
      
    },
     {
      id: 2,
      question:"Which book has the character “Mowgli”?",
     options:[
         "Harry Potter",
        "The Jungle Book",
        "Ramayana",
        "The Adventures of Tom Sawyer",
     ],
     correctAnswer:"The Jungle Book",
      
    },
     {
      id: 3,
      question:"Who was the wife of Lord Rama in Ramayana?",
     options:[
         "Draupadi",
        "Radha",
        "Sita",
        "Rukmini",
     ],
     correctAnswer:"Sita",
      
    },
     {
      id: 4,
      question:"Who wrote Ramayana?",
     options:[
         "Valmiki",
        "Tulsidas",
        "Ved Vyasa",
        "Kalidasa",
     ],
     correctAnswer:"Valmiki",
      
    },
     {
      id: 5,
      question:"Which animal helped Lord Rama in the Ramayana?",
     options:[
         "Elephant",
        "Monkey Army",
        "Tiger",
        "Horse",
     ],
     correctAnswer:"Monkey Army",
      
    },
     {
      id: 6,
      question:"Who was the main villain in Ramayana?",
     options:[
         "Kansa",
        "Duryodhana",
        "Ravana",
        "Shakuni",
     ],
     correctAnswer:"Ravana",
      
    },
     {
      id: 7,
      question:"Who guided Arjuna in Mahabharata?",
     options:[
         "Hanuman",
        "Lord Krishna",
        "Bhishma",
        "Karna",
     ],
     correctAnswer:"Lord Krishna",
      
    },
     {
      id: 8,
      question:"How many Pandavas were there in the Mahabharata?",
     options:[
         "3",
        "4",
        "5",
        "6",
     ],
     correctAnswer:"5",
      
    },
     {
      id: 9,
      question:"Who wrote Mahabharata?",
     options:[
         "Valmiki",
        "Ved Vyasa",
        "Tulsidas",
        "Kalidasa",
     ],
     correctAnswer:"Ved Vyasa",
      
    },
     {
      id: 10,
      question:"Which book contains the Bhagavad Gita?",
     options:[
         "Ramayana",
        "Mahabharata",
        "Bhagavad Gita",
        "Upanishads",
     ],
     correctAnswer:"Mahabharata",
      
    },
],

  travel: [
    {
      id: 1,
      question:"Which city is known as the Pink City of India?",
     options:[
         "Delhi",
        "Jaipur",
        "Mumbai",
        "Surat",
     ],
     correctAnswer:"Jaipur",
      
    },
     {
      id: 2,
      question:"The Taj Mahal is located in which Indian state?",
     options:[
         "Gujarat",
        "Rajasthan",
        "Uttar Pradesh",
        "Maharashtra",
     ],
     correctAnswer:"Uttar Pradesh",
      
    },
     {
      id: 3,
      question:"Which Indian state is famous for backwaters and houseboats?",
     options:[
         "Kerala",
        "Punjab",
        "Goa",
        "Assam",
     ],
     correctAnswer:"Kerala",
      
    },
     {
      id: 4,
      question:"Which country is famous for the Eiffel Tower?",
     options:[
         "Italy",
        "France",
        "Germany",
        "Spain",
     ],
     correctAnswer:"France",
      
    },
     {
      id: 5,
      question:"Which Indian city is famous for the Gateway of India?",
     options:[
         "Chennai",
        "Kolkata",
        "Mumbai",
        "Hyderabad",
     ],
     correctAnswer:"Mumbai",
      
    },
     {
      id: 6,
      question:"Which transport is used to travel in the sky?",
     options:[
         "Train",
        "Boat",
        "Airplane",
        "Bus",
     ],
     correctAnswer:"Airplane",
      
    },
     {
      id: 7,
      question:"Which country is famous for pyramids?",
     options:[
         "India",
        "Egypt",
        "italy",
        "Greece",
     ],
     correctAnswer:"Egypt",
      
    },
     {
      id: 8,
      question:"Which city is known as the “City of Love”?",
     options:[
         "London",
        "Paris",
        "Dubai",
        "Rome",
     ],
     correctAnswer:"Paris",
      
    },
     {
      id: 9,
      question:"Which document is needed for international travel?",
     options:[
         "Ration Card",
        "Passport",
        "PAN Card",
        "Library Card",
     ],
     correctAnswer:"Passport",
      
    },
     {
      id: 10,
      question:"Which continent is known for the Sahara Desert?",
     options:[
         "Asia",
        "Europe",
        "Africa",
        "Sydney",
     ],
     correctAnswer:"Africa",
      
    },
],
  art: [
    {
      id: 1,
      question:"Who painted Mona Lisa?",
     options:[
         "Pablo Picasso",
        "Vincent van Gogh",
        "Leonardo da Vinci",
        "Michelangelo",
     ],
     correctAnswer:"Leonardo da Vinci",
      
    },
     {
      id: 2,
      question:"Which colors are called primary colors?",
     options:[
         "Red, Blue, Yellow",
        "Green, Orange, Purple",
        "Black, White, Gray",
        "Pink, Brown, Blue",
     ],
     correctAnswer:"Red, Blue, Yellow",
      
    },
     {
      id: 3,
      question:"Which tool is commonly used for painting?",
     options:[
         "Hammer",
        "Brush",
        "Knife",
        "Spoon",
     ],
     correctAnswer:"Brush",
      
    },
     {
      id: 4,
      question:"Who painted The Starry Night?",
     options:[
         "Pablo Picasso",
        "Vincent van Gogh",
        "Claude Monet",
        "Salvador Dalí",
     ],
     correctAnswer:"Vincent van Gogh",
      
    },
     {
      id: 5,
      question:"Which art form uses clay to create objects?",
     options:[
         "Sketching",
        "Painting",
        "Sculpture",
        "Dancing",
     ],
     correctAnswer:"Sculpture",
      
    },
     {
      id: 6,
      question:"Which famous artist cut off part of his ear?",
     options:[
         "Leonardo da Vinci",
        "Pablo Picasso",
        "Vincent van Gogh",
        "Michelangelo",
     ],
     correctAnswer:"Vincent van Gogh",
      
    },
     {
      id: 7,
      question:"What do artists use to mix colors?",
     options:[
         "Plate",
        "Palette",
        "Notebook",
        "Scale",
     ],
     correctAnswer:"Palette",
      
    },
     {
      id: 8,
      question:"Which country is famous for the art style called Origami?",
     options:[
         "China",
        "India",
        "Japan",
        "Italy",
     ],
     correctAnswer:"Japan",
      
    },
     {
      id: 9,
      question:"What is a person called who creates paintings?",
     options:[
         "Singer",
        "Dancer",
        "Painter",
        "Writer",
     ],
     correctAnswer:"Painter",
      
    },
     {
      id: 10,
      question:"Which famous artwork was painted by Leonardo da Vinci?",
     options:[
         "The Scream",
        "Guernica",
        "Mona Lisa",
        "Sunflowers",
     ],
     correctAnswer:"Mona Lisa",
      
    },
],
  geography: [
    {
      id: 1,
      question:"Which is the largest continent in the world?",
     options:[
         "Africa",
        "Europe",
        "Asia",
        "Australia",
     ],
     correctAnswer:"Asia",
      
    },
     {
      id: 2,
      question:"Which is the longest river in the world?",
     options:[
         "Amazon River",
        "Nile River",
        "Ganga River",
        "Yangtze River",
     ],
     correctAnswer:"Nile River",
      
    },
     {
      id: 3,
      question:"Which country has the largest population in the world?",
     options:[
         "India",
        "China",
        "USA",
        "Russia",
     ],
     correctAnswer:"India",
      
    },
     {
      id: 4,
      question:"Which desert is the largest hot desert in the world?",
     options:[
         "Gobi Desert",
        "Sahara Desert",
        "Thar Desert",
        "Arabian Desert",
     ],
     correctAnswer:"Sahara Desert",
      
    },
     {
      id: 5,
      question:"Which ocean is the largest on Earth?",
     options:[
         "Atlantic Ocean",
        "Indian Ocean",
        "Arctic Ocean",
        "Pacific Ocean",
     ],
     correctAnswer:"Pacific Ocean",
      
    },
     {
      id: 6,
      question:"Mount Everest is located in which mountain range?",
     options:[
         "Alps",
        "Andes",
        "Himalayas",
        "Rockies",
     ],
     correctAnswer:"Himalayas",
      
    },
     {
      id: 7,
      question:"Which country is known as the Land of the Rising Sun?",
     options:[
         "China",
        "Thailand",
        "Japan",
        "South Korea",
     ],
     correctAnswer:"Japan",
      
    },
     {
      id: 8,
      question:"What is the capital city of Australia?",
     options:[
         "Sydney",
        "Melbourne",
        "Canberra",
        "Perth",
     ],
     correctAnswer:"Canberra",
      
    },
     {
      id: 9,
      question:"Which Indian river is considered the holiest?",
     options:[
         "Yamuna",
        "Brahmaputra",
        "Godavari",
        "Ganga",
     ],
     correctAnswer:"Ganga",
      
    },
     {
      id: 10,
      question:"Which continent is the smallest in the world?",
     options:[
         "Europe",
        "Antarctica",
        "Australia",
        "South America",
     ],
     correctAnswer:"Australia",
      
    },
],
  food: [
    {
      id: 1,
      question:"Which fruit is known as the King of Fruits?",
     options:[
         "Apple",
        "Banana",
        "Mango",
        "Pineapple",
     ],
     correctAnswer:"Mango",
      
    },
     {
      id: 2,
      question:"Which country is famous for pizza?",
     options:[
         "India",
        "Italy",
        "China",
        "Mexico",
     ],
     correctAnswer:"Italy",
      
    },
     {
      id: 3,
      question:"What is the main ingredient in French fries?",
     options:[
         "Tomato",
        "Potato",
        "Onion",
        "Carrot",
     ],
     correctAnswer:"Potato",
      
    },
     {
      id: 4,
      question:"Which drink is made from tea leaves?",
     options:[
         "Coffee",
        "Juice",
        "Tea",
        "Soda",
     ],
     correctAnswer:"Tea",
      
    },
     {
      id: 5,
      question:"Sushi is a famous food from which country?",
     options:[
         "China",
        "Thailand",
        "Japan",
        "South Korea",
     ],
     correctAnswer:"Japan",
      
    },
     {
      id: 6,
      question:"Which vitamin is mainly found in oranges and lemons?",
     options:[
         "Vitamin A",
        "Vitamin B",
        "Vitamin C",
        "Vitamin D",
     ],
     correctAnswer:"Vitamin C",
      
    },
     {
      id: 7,
      question:"Which food is known as the staple food of South India?",
     options:[
         "Pizza",
        "Rice",
        "Pasta",
        "Bread",
     ],
     correctAnswer:"Rice",
      
    },
     {
      id: 8,
      question:"What is the main ingredient of bread?",
     options:[
         "Rice",
        "Wheat flour",
        "Corn",
        "Sugar",
     ],
     correctAnswer:"Wheat flour",
      
    },
     {
      id: 9,
      question:"Which food is famous in Gujarat?",
     options:[
         "Dhokla",
        "bhajiya",
        "Fafda",
        "Thepla",
     ],
     correctAnswer:"Dhokla",
      
    },
     {
      id: 10,
      question:"Which Indian sweet is white and soft, made from milk?",
     options:[
         "Jalebi",
        "Rasgulla",
        "Laddu",
        "Barfi",
     ],
     correctAnswer:"Rasgulla",
      
    },
   ],
  finance : [
  {
    id: 1,
    question: "What is the extra money you earn on savings kept in a bank called?",
    options: [
      "Interest",
      "Rent",
      "Tax",
      "Fine",
    ],
    correctAnswer: "Interest",
  },
  {
    id: 2,
    question: "What does 'ATM' stand for?",
    options: [
      "Automated Teller Machine",
      "Account Transfer Mode",
      "Automatic Tax Manager",
      "Approved Trade Money",
    ],
    correctAnswer: "Automated Teller Machine",
  },
  {
    id: 3,
    question: "What is a budget mainly used for?",
    options: [
      "Planning income and expenses",
      "Playing games",
      "Sending emails",
      "Editing photos",
    ],
    correctAnswer: "Planning income and expenses",
  },
  {
    id: 4,
    question: "What is money borrowed from a bank that must be repaid called?",
    options: [
      "Loan",
      "Gift",
      "Bonus",
      "Refund",
    ],
    correctAnswer: "Loan",
  },
  {
    id: 5,
    question: "What does 'GDP' stand for in economics?",
    options: [
      "Gross Domestic Product",
      "General Data Plan",
      "Global Digital Payment",
      "Grand Detailed Plan",
    ],
    correctAnswer: "Gross Domestic Product",
  },
  {
    id: 6,
    question: "What is the general rise in prices of goods and services over time called?",
    options: [
      "Inflation",
      "Deduction",
      "Discount",
      "Savings",
    ],
    correctAnswer: "Inflation",
  },
  {
    id: 7,
    question: "What is buying a small part of a company in the stock market called?",
    options: [
      "Buying shares",
      "Paying tax",
      "Taking a loan",
      "Opening an ATM",
    ],
    correctAnswer: "Buying shares",
  },
  {
    id: 8,
    question: "What is a digital or virtual currency like Bitcoin called?",
    options: [
      "Cryptocurrency",
      "Paper money",
      "Coupon",
      "Gift card",
    ],
    correctAnswer: "Cryptocurrency",
  },
  {
    id: 9,
    question: "What is the money you set aside for future use called?",
    options: [
      "Savings",
      "Expense",
      "Debt",
      "Bill",
    ],
    correctAnswer: "Savings",
  },
  {
    id: 10,
    question: "What is a regular payment made to insure your life or property called?",
    options: [
      "Premium",
      "Profit",
      "Salary",
      "Bonus",
    ],
    correctAnswer: "Premium",
  },
],

};

export default quizData;